export enum NewEnumCacheType {
  AIRPORTTAXESINCLUDED = 'AIRPORTTAXESINCLUDED',
  AIRPORTTAXESNOTINCLUDED = 'AIRPORTTAXESNOTINCLUDED',
}
